import { render, staticRenderFns } from "./perWarn.vue?vue&type=template&id=78bdbba2&scoped=true&"
import script from "./perWarn.vue?vue&type=script&lang=js&"
export * from "./perWarn.vue?vue&type=script&lang=js&"
import style0 from "./perWarn.vue?vue&type=style&index=0&id=78bdbba2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bdbba2",
  null
  
)

export default component.exports